<template>
  <div class="multiselectCustomComp">

      <div class="div_btns">
        <button :disabled="btnAllDis" @click="value = options" class="btn_all">&harr;</button>
        <button :disabled="btnResetDis" @click="value = []" class="btn_reset">&#8617;</button>
      </div>
      <multiselect
        v-model="value"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="true"
        :preserve-search="true"
        placeholder="Выбрать"
        :label="name"
        :track-by="name"
        :preselect-first="false"
        :selectLabel="'Выбрать'"
        :selectedLabel="'Выбран'"
        :deselectLabel="'Сброс'"
        :showLabels="true"
        :disabled="disabled"
      >
        <template
          slot="selection"
          slot-scope="{ values, search, isOpen }"
        >
          <span
            class="multiselect__single"
            v-if="values.length &amp;&amp; !isOpen">{{ values.length }} выбрано
          </span>
        </template>
      </multiselect>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'multiselectComp',
  props: {
    options: Array,
    name: String,
    disabled: {
      type: Boolean,
      default: () => { return false }
    },
    values: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function () {
    return {
      value: this.values
    }
  },
  created: function () {
    this.value = this.values
  },
  mounted () {},
  components: {
    Multiselect
  },
  computed: {
    btnAllDis: function () {
      if (this.disabled == true) return true
      else return this.value == this.options
    },
    btnResetDis: function () {
      if (this.disabled == true) return true
      else return !this.value.length
    }
  },
  watch: {
    values: function (v) {
      this.value = v
    }
  },
  methods: {
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">

.multiselectCustomComp {
  position: relative;
}
.btn_all {
  position: absolute;
  z-index: 500;
  background-color: #ff8200;
  border-radius: 50%;
  border: none;
  color: #ffffff;
  width: 22px;
  height: 22px;
  top: calc(50% - 14px);
  right: 35px;
}
.btn_reset {
  position: absolute;
  z-index: 500;
  background-color: #ff8200;
  border-radius: 50%;
  border: none;
  color: #ffffff;
  width: 22px;
  height: 22px;
  top: calc(50% - 14px);
  right: 65px;
}
button:hover, button:active {
  opacity: 0.5;
}
.multiselect--active {
  z-index: 5000;
}
</style>
